interface ICardFooterProps {
  post: TPost;
}

function CardFooter({post}: ICardFooterProps) {
  return (
    <div>
      <div className="d-flex align-items-center pt-1 justify-content-between">
        <div className="d-flex align-items-center">
          <i className="icon-location color-gray-9"></i>
          <small className="pe-1 color-gray-1">
            {post?.state
              ? typeof post?.state === 'object'
                ? post?.state?.name
                : post?.state
              : ''}

            {post?.city ? (
              typeof post?.city === 'object' ? (
                <>، {post?.city?.name}</>
              ) : (
                post?.city && <>، {post?.city}</>
              )
            ) : (
              ''
            )}
          </small>
        </div>

        {post?.store && (
          <div className="d-flex align-items-center">
            <i className="icon-Star color-gold-custom"></i>
            <small className="color-gray-9 pe-1">{post?.store?.rate}</small>
          </div>
        )}
      </div>
    </div>
  );
}

export default CardFooter;
